import Controller from "@ember/controller";
import { action } from "@ember/object";
import { getOwner } from "@ember/owner";
import { service } from "@ember/service";

const TABS = ["all", "hot", "followed"];

export default class ModMarketController extends Controller {
  @service currentUser;
  @service router;

  queryParams = ["tab", "game", "character", "type", "sort", "q", "page"];

  tab = "all";
  game = null;
  character = null;
  type = null;
  sort = "latest";
  q = "";
  page = 0;

  get currentPage() {
    return this.model.meta.page + 1;
  }

  get canGoBack() {
    return this.model.meta.page > 0;
  }

  get canGoForward() {
    return this.model.meta.page + 1 < this.model.meta.total_pages;
  }

  transition(queryParams) {
    this.router.transitionTo("mod-market", {
      queryParams: {
        tab: this.tab,
        game: this.game,
        character: this.character,
        type: this.type,
        sort: this.sort,
        q: this.q,
        page: this.page,
        ...queryParams,
      },
    });
  }

  @action
  selectTab(tab) {
    if (tab === "followed" && !this.currentUser) {
      getOwner(this).lookup("route:application").send("showLogin");
      return;
    }

    const filters =
      tab === "followed"
        ? { character: null, type: null, sort: "latest", q: "" }
        : {};
    this.transition({ tab, page: 0, ...filters });
  }

  @action
  navigateTabs(tab, event) {
    const nextTab = this.nextTab(tab, event.key);
    if (!nextTab) {
      return;
    }

    event.preventDefault();
    event.currentTarget.parentElement
      .querySelector(`[data-mod-market-tab="${nextTab}"]`)
      ?.focus();
    this.selectTab(nextTab);
  }

  @action
  selectGame(game) {
    this.transition({ game: this.game === game ? null : game, character: null, page: 0 });
  }

  @action
  selectCharacter(event) {
    this.transition({ character: event.target.value || null, page: 0 });
  }

  @action
  searchOnBlur(event) {
    const q = event.target.value;

    if (q !== this.q) {
      this.transition({ q, page: 0 });
    }
  }

  @action
  selectType(type) {
    this.transition({ type: this.type === type ? null : type, page: 0 });
  }

  @action
  selectSort(sort) {
    this.transition({ sort, page: 0 });
  }

  @action
  previousPage() {
    if (this.canGoBack) {
      this.transition({ page: this.model.meta.page - 1 });
    }
  }

  @action
  nextPage() {
    if (this.canGoForward) {
      this.transition({ page: this.model.meta.page + 1 });
    }
  }

  nextTab(tab, key) {
    const currentIndex = TABS.indexOf(tab);
    switch (key) {
      case "ArrowLeft":
        return TABS[(currentIndex - 1 + TABS.length) % TABS.length];
      case "ArrowRight":
        return TABS[(currentIndex + 1) % TABS.length];
      case "Home":
        return TABS[0];
      case "End":
        return TABS.at(-1);
    }
  }
}
